var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKenya = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#kenya_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000001",
  d: "M0 0h32v7.2H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#060",
  d: "M0 16.8h32V24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.375,
  d: "m11.71 19.125.27.15 7.005-12.15c.405-.09.63-.48.855-.87.15-.27.75-1.305 1.005-2.655a8.7 8.7 0 0 0-1.785 2.205c-.225.39-.45.78-.345 1.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11.71 19.125.27.15 7.005-12.15c.405-.09.63-.48.855-.87.15-.27.75-1.305 1.005-2.655a8.7 8.7 0 0 0-1.785 2.205c-.225.39-.45.78-.345 1.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.375,
  d: "m20.29 19.125-.27.15-7.005-12.15c-.405-.09-.63-.48-.855-.87-.15-.27-.75-1.305-1.005-2.655a8.7 8.7 0 0 1 1.785 2.205c.225.39.45.78.345 1.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m20.29 19.125-.27.15-7.005-12.15c-.405-.09-.63-.48-.855-.87-.15-.27-.75-1.305-1.005-2.655a8.7 8.7 0 0 1 1.785 2.205c.225.39.45.78.345 1.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B00",
  d: "M32.025 8.4H18.85C18.4 7.2 16.9 4.8 16 4.8s-2.4 2.4-2.85 3.6H-.01v7.2h13.16c.45 1.2 1.95 3.6 2.85 3.6s2.4-2.4 2.85-3.6h13.175z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M18.85 15.6c.45-1.2.75-2.4.75-3.6s-.3-2.4-.75-3.6c-.45 1.2-.75 2.4-.75 3.6s.3 2.4.75 3.6m-5.7 0c-.45-1.2-.75-2.4-.75-3.6s.3-2.4.75-3.6c.45 1.2.75 2.4.75 3.6s-.3 2.4-.75 3.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 12.9c.331 0 .6-.403.6-.9s-.269-.9-.6-.9c-.332 0-.6.403-.6.9s.268.9.6.9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.15 12.87s.6 1.2.6 3.15-.6 3.15-.6 3.15zm-.3-1.74s-.6-1.2-.6-3.15.6-3.15.6-3.15zm0 1.74s-.6 1.2-.6 3.15.6 3.15.6 3.15zm.3-1.74s.6-1.2.6-3.15-.6-3.15-.6-3.15z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "kenya_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
})))));
export default SvgKenya;